module.exports = __webpack_public_path__ + "img/dart-character.933ec781.png";